module.exports = __webpack_public_path__ + "media/newstyle/images/publico2-4ac6f085368fddc8a1632ecc53a79e92.png";